export const CommonColor = {
    FFFFFF: '#fff',
    F2F2F2: '#F3F5F7',
    CCCCCC: '#CCCCCC',
    FCFCFC: '#fcfcfc',
};
